export class TokenInfo {
    accessToken?: string | null;
    expiresIn?: number | null;
    refreshToken?: string | null;
    tokenType?: string | null;
}
